import {
    createPromotionalCard,
    IPromotionalCardBusinessLogic,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { startAppListening } from 'Container/App/listener';
import { selectDataVolume } from 'Container/App/selectors';
import {
    CASHBACK_PROMOTIONAL_CARD_CONTAINER,
    GIGADEPOT_PROMOTIONAL_CARD_CONTAINER,
} from 'Container/App/constants';
import { selectCustomerConfig } from 'Container/App/slice';

const mountPromotionalCard = (id: string, business: IPromotionalCardBusinessLogic = NO_PATTERN_BUSINESS_LOGIC): PromotionalCard | null => {
    const promotionalCard = createComponentById(createPromotionalCard, id, business);

    if (!promotionalCard) {
        return null;
    }

    return promotionalCard;
};

/**
 * Mount Gigadepot promotional card
 */
export const mountGigaDepotPromotionalCard = (): PromotionalCard | null => {
    const promotionalCard = mountPromotionalCard(GIGADEPOT_PROMOTIONAL_CARD_CONTAINER);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectDataVolume(currentState) !== selectDataVolume(previousState),
        effect: (_action, api) => {
            const dataVolume = selectDataVolume(api.getState());

            promotionalCard?.toggleContainer(dataVolume?.unlimited || false);
        },
    });

    return promotionalCard;
};

/**
 * Mount cashback promotional card
 */
export const mountCashbackPromotionalCard = (): PromotionalCard | null => {
    const promotionalCard = mountPromotionalCard(CASHBACK_PROMOTIONAL_CARD_CONTAINER);

    promotionalCard && startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).hasCashback !== selectCustomerConfig(previousState).hasCashback,
        effect: (_action, api) => {
            const properties = promotionalCard!.getProperties()!;

            const { hasCashback } = selectCustomerConfig(api.getState());

            const { containerFormSelectionControl, stdConfirmationText } = properties;
            const checkbox = containerFormSelectionControl!.items[0];

            hasCashback && promotionalCard!.update({
                containerFormSelectionControl: {
                    ...containerFormSelectionControl!,
                    items: [{
                        ...checkbox,
                        optState: 'checked',
                        txtLabelText: `<p>${stdConfirmationText}</p>`,
                    }],
                },
            });
        },
    });

    return promotionalCard;
};
